<template>
  <div class="subject-box">
    <div class="subject-box-title">
      <div class="title-left">
        <p class="china-title">{{currentQuestionList1.tips_cnname}}</p>
        <p class="en-title">{{currentQuestionList1.tips_enname}}</p>
      </div>
      <div class="title-right" v-if="currentQuestionList1.has_audio==1">
        <div class="audio-add" @click="playAudio">
          <div class="audio-box" style="position:relative;z-index:10;"></div>
          <audio
            class="audio"
            :id="`audioPlay${propIndex}`"
            ref="audio"
            controls
            :src="currentQuestionList1.question_audio"
            autoplay 
          ></audio>
        </div>
      </div>
    </div>
    <div class="subject-content-box">
      <div class="subject-content wordSelect-type">
        <div class="word-box" v-html="currentQuestionList1.question_title"></div>
        <div class="isHasImg">
          <img :src="currentQuestionList1.question_titleimg" alt />
        </div>
        <div class="wordSelect-box">
          <div class="item" v-for="(item,index) of currentQuestionList1.option" :key="index">
            <input
            @change="wordChange(currentQuestionList1.question_id, item.answers_optionname)"
              type="radio"
              :name="`word${propIndex?propIndex:0}`"
              class="chooseChecked checked"
              :id="`one${currentQuestionList1.question_id}_${index}`"
              :value="item.answers_optionname"
              v-model="anwsersAll.answers"
            />
            <label :for="`one${currentQuestionList1.question_id}_${index}`" class="label-box">
              <div class="word-value">{{item.answers_option}}</div>
              <span class="option">{{item.answers_optionname}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wordSelection",
  props: {
    currentQuestionList: {
      type: Object
    },
    anwsersAll: {
      type: Object
    },//当前题目答案-格式
    propIndex:{
      type: Number
    },
    propChild: {
      type: Object
    }
  },
  data() {
    return {
      currentQuestionList1: {},
      picked: [],
      question: {
        word:
          "Chevady:Wake up，Matt.<br/>Matt:$B$<br/>Chevady:It is Saturday!Let is go out and play.",
        list: [
          {
            id: 0,
            value: "Goodbye.",
            option: "A"
          },
          {
            id: 1,
            value: "Goodbye.",
            option: "B"
          },
          {
            id: 2,
            value: "Goodbye.",
            option: "C"
          },
          {
            id: 3,
            value: "Happy birthday.",
            option: "D"
          }
        ],
        Index: -1,
        flag: false
      }
    };
  },
  created() {
    console.log(this.propChild, "我接收到的数据");
    this.currentQuestionList1 = this.propChild?this.propChild:this.currentQuestionList;
  },
  watch: {
    getData(n, o) {
      console.log(22222);
      // console.log(n, o,'我接收到的数据');
      this.currentQuestionList1 = n;
      console.log(this.currentQuestionList1, "我接收到的数据");
    },
    getData1(n, o) {
      console.log(22222);
      console.log(n, "我是文字选折");
      this.currentQuestionList1 = n;
      console.log(this.currentQuestionList1, "我接收到的数据11,我是文字选折");
    }
  },
  computed: {
    getData() {
      return this.currentQuestionList;
    },
    getData1() {
      return this.propChild;
    }
  },
  // props: ['title'],
  methods: {
    //正则转换
    questionWay(str) {
      console.log(str);
    },
    playAudio() {
      console.log(333);
      let audio = this.$refs.audio;
      console.log(audio)
      audio.play();
    },
    //文字选择
    wordChange(v1,v2){
      console.log('文字选择')
      this.$emit('wordChange', v1, v2)
    },
  }
};
</script>

<style lang="less">
</style>
